export default __webpack_public_path__ + "042ddb96d6668df5598937b1d10e38e5.png";